<template>
  <div>
    <header-component/>
    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="card-header">
          <h3 
            class="mb-0" 
            style="text-transform:capitalize;">Expense List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button 
              size="sm" 
              type="primary" 
              @click="createExpense">Add New</base-button>
          </div>
        </div>

        <el-table
          :data="expenseList"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column 
            label="Date" 
            min-width="170px" 
            prop="date" 
            sortable>
            <template slot-scope="scope">
              {{ scope.row.date | convertDate }}
            </template>
          </el-table-column>
          <el-table-column 
            label="Expense Type" 
            min-width="170px" 
            sortable>
            <template slot-scope="scope">
              {{ scope.row.expenseType.label }}
            </template>
          </el-table-column>
          <el-table-column 
            label="Expense Amount" 
            min-width="170px" 
            prop="amount" 
            sortable/>
          <el-table-column 
            label="Description" 
            min-width="170px" 
            prop="description" 
            sortable/>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown 
                slot="dropdown" 
                @command="command => handleAction(scope.row, command)">
                <el-button 
                  type="primary" 
                  size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu 
                  slot="dropdown" 
                  class="dropdown-menu dropdown-menu-arrow show">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog 
        :visible.sync="addExpense" 
        title="Add Expense ">
        <div>
          <add-expense @close =" addExpense = false "/>
        </div>
      </el-dialog>
    </div>
  </div>

</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import AddExpense from "./AddExpense";
import { mapGetters,mapActions ,mapMutations} from "vuex";
import { format } from "date-fns";
import headerComponent from "../Components/HeaderComponent";

export default {
   filters: {
    convertDate(date) {
      return format(date, "YYYY-MM-DD");
    }
  },
  data: () => {
    return {
    
      addExpense: false
    };
  },

  computed: {
    ...mapGetters({
      expenseList: "expense/getExpenseList",
       expense : "expense/getExpense",
    })
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    "add-expense": AddExpense,
    [Dialog.name]: Dialog,
    [Button.name] : Button,
    "header-component" : headerComponent
  },

  mounted(){
    this.getExpenses();
  },

  methods: {
    ...mapActions({getExpenses:"expense/getExpenses", fetchExpense:"expense/fetchExpense"}),
   ...mapMutations({ setExpense : "expense/setExpense", resetExpense : "expense/resetExpense"}),
   handleAction(expense, command) {
      if (command === "edit") {
        this.fetchExpense(expense.expenseId).then((res) => {
           this.addExpense = true;
           this.setExpense(res);  
         })
      }
    },
    createExpense() {
      this.resetExpense();
      this.addExpense = true;
    }
  }
};
</script>